const BLOCKED = ['/login', '/register', '/forgot-password', '/reset-password', '/email-confirmed'];

const safePath = (path) => {
  if (!path || typeof path !== 'string') return null;
  let p = path;
  try { p = decodeURIComponent(path); } catch { /* keep raw */ }
  if (!p.startsWith('/') || p.startsWith('//') || p.includes('\\')) return null;
  if (BLOCKED.some((b) => p === b || p.startsWith(`${b}?`) || p.startsWith(`${b}/`))) return null;
  return p;
};

// Explicit redirect wins; otherwise admins land on /admin and clients on their default page.
export const landingPathFor = (user, explicitPath, clientDefault) => {
  const explicit = safePath(explicitPath);
  if (explicit) return explicit;
  return user?.roles?.includes('admin') ? '/admin' : clientDefault;
};
